import accounting from './accounting.json';
import common from './common.json';
import admin from './admin.json';
import validation from './validation.json';
import main from './main.json';
import orders from './orders.json';
import componentLibrary from './componentLibrary.json';
import funding from './funding.json';
import fundingAdmin from './fundingAdmin.json';
import settlements from './settlements.json';
import deposits from './deposits.json';
import directory from './directory.json';
import users from './users.json';
import documents from './documents.json';
import premiumFees from './premiumFees.json';
import profileMenu from './profileMenu.json';
import geo from './geo.json';
import profile from './profile.json';
import titles from './titles.json';
import hierarchy from './hierarchy.json';
import payoffs from './payoffs.json';
import parties from './parties.json';
import titlesAdmin from './titlesAdmin.json';
import knowledgeBase from './knowledgeBase.json';
import imageUploader from './imageUploader.json';
import directoryManager from './directoryManager.json';
import workflowAdmin from './workflowAdmin.json';
import notes from './notes.json';
import forgotPasswordForm from './forgotPasswordForm.json';
import workflow from './workflow.json';
import dashboard from './dashboard.json';
import integrationMarketplace from './integrationMarketplace.json';
import insights from './insights.json';
import error from './error.json';

export default {
  accounting,
  common,
  admin,
  validation,
  main,
  profile,
  orders,
  componentLibrary,
  funding,
  fundingAdmin,
  settlements,
  deposits,
  directory,
  users,
  documents,
  premiumFees,
  profileMenu,
  geo,
  titles,
  titlesAdmin,
  hierarchy,
  payoffs,
  parties,
  knowledgeBase,
  imageUploader,
  directoryManager,
  workflowAdmin,
  notes,
  forgotPasswordForm,
  workflow,
  dashboard,
  integrationMarketplace,
  insights,
  error,
} as const;
